export default {"src":"/_next/static/media/desk.7f5ad094.svg","height":100,"width":100};